import { useState } from 'react';
import dayjs from 'dayjs';
import { Skeleton } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarCheck } from '@fortawesome/free-solid-svg-icons';
import { Muted, PrimaryBtn } from '../../components';
import { useAvailabilityQuery } from '../../queries/scheduling';
import { useBookTour } from '../../queries/prospects';
import * as S from './styled';

const RANGE = { from: dayjs().format('YYYY-MM-DD'), days: 8 };

export default function TourPicker({ prospect, canManage }) {
  const { data: days = [], isLoading } = useAvailabilityQuery(RANGE);
  const book = useBookTour();
  const [picked, setPicked] = useState({ day: null, slot: null });
  const dayIndex = picked.day ?? Math.max(0, days.findIndex((d) => d.slots.length));
  const slots = days[dayIndex]?.slots || [];
  const slot = slots[picked.slot ?? -1];

  const submit = () =>
    book.mutate({ id: prospect._id, start: slot.startISO }, { onSuccess: () => setPicked({ day: null, slot: null }) });

  return (
    <S.Divided aria-labelledby="tour-head">
      <h3 id="tour-head">Book / reschedule tour</h3>
      {isLoading ? (
        <Skeleton active title={false} paragraph={{ rows: 3 }} />
      ) : (
        <>
          <S.Days role="group" aria-label="Day">
            {days.map((d, i) => (
              <S.Day
                key={d.date}
                type="button"
                $on={i === dayIndex}
                aria-pressed={i === dayIndex}
                disabled={!canManage || !d.slots.length}
                onClick={() => setPicked({ day: i, slot: null })}
              >
                <b>{dayjs(d.date).format('D')}</b>
                <span>{dayjs(d.date).format('ddd').toUpperCase()}</span>
                <small>{d.slots.length} open</small>
              </S.Day>
            ))}
          </S.Days>
          {slots.length ? (
            <S.Slots role="group" aria-label="Time">
              {slots.map((s, i) => (
                <S.Slot key={s.startISO} type="button" disabled={!canManage} $on={i === picked.slot} aria-pressed={i === picked.slot} onClick={() => setPicked({ day: dayIndex, slot: i })}>
                  {dayjs(s.startISO).format('h:mm A')}
                </S.Slot>
              ))}
            </S.Slots>
          ) : (
            <Muted>No open times this day.</Muted>
          )}
        </>
      )}
      {canManage && (
        <S.BookRow>
          <PrimaryBtn type="button" style={{ height: 40 }} disabled={!slot || book.isPending} onClick={submit}>
            <FontAwesomeIcon icon={faCalendarCheck} />
            {prospect.tour?.bookingId ? 'Reschedule tour' : 'Book tour'}
          </PrimaryBtn>
          <span>Sends confirmation text and adds to the leasing calendar.</span>
        </S.BookRow>
      )}
    </S.Divided>
  );
}
